var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0723854 0.478603C0.196542 0.216875 0.460325 0.0500488 0.750008 0.0500488H16.2046C16.4942 0.0500488 16.758 0.216875 16.8822 0.478603C17.0063 0.740331 16.9687 1.05016 16.7854 1.27451L10.7727 8.63543V15.2C10.7727 15.4619 10.6362 15.7047 10.4126 15.8408C10.1889 15.9769 9.91046 15.9865 9.67795 15.8661L6.58705 14.2661C6.33812 14.1372 6.18183 13.8803 6.18183 13.6V8.63543L0.169157 1.27451C-0.0141 1.05016 -0.0517711 0.740331 0.0723854 0.478603ZM2.33104 1.55005L7.51268 7.89359C7.62207 8.02751 7.68183 8.19512 7.68183 8.36805V13.1438L9.27273 13.9673V8.36805C9.27273 8.19512 9.33249 8.02751 9.44188 7.89359L14.6235 1.55005H2.33104Z",
    fill: "#735BF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.c2fef70fd5bb9b8c16d5fa5556745627.svg";
export { ForwardRef as ReactComponent };